<template><div><h1>VUX V2.1.1Rc.5 发布日志</h1>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 修复 render-function 变化不重新渲染的问题</li>
</ul>
<h2><a href="/zh-CN/components/md5.html">Md5</a></h2>
<ul><li>[feature] 修复 import 和 module.exports 混用的问题 #1007 @zack24q</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.5-212.vue?150ed534